import { Image, Text } from '@chakra-ui/react';
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { fetchHomePageInfo } from '../../../../slice/loggedOutHomeSlice';

import './Section2.css';

import availabilityIcon from './24-hours.png';
import certificateIcon from './certificate.png';
import collaborationIcon from './collaboration.png';

function Section2() {
  const dispatch = useDispatch();
  const numCollaborations = useSelector(state => state.loggedOutHome.numCollaborations);
  const numCertificates = useSelector(state => state.loggedOutHome.numCertificates);

  useEffect(() => {
    dispatch(fetchHomePageInfo());
  }, [dispatch]);

  const StatsDisplay = (value, label, imgSrc, delay) => (
    <div className="stats-card" style={{ animationDelay: `${delay}s` }}>
      <div className="stats-icon">
        <Image src={imgSrc} alt="" />
      </div>

      <Text className="stats-value">{value}</Text>
      <Text className="stats-label">{label}</Text>
    </div>
  );

  return (
    <div className="section2-wrapper">

      <div className="section2-banner">
        <Text className="section2-banner-title">
          We provide round-the-clock certificate verification service
        </Text>
      </div>

      <Text className="section2-subtitle">
        View & Verify. Anytime. Anywhere.
      </Text>

      <div className="stats-container">
        {StatsDisplay(numCollaborations, "Collaborations", collaborationIcon, 0.1)}
        {StatsDisplay("24/7", "Certification Availability", availabilityIcon, 0.25)}
        {StatsDisplay(numCertificates, "Certificates Issued", certificateIcon, 0.4)}
      </div>
    </div>
  );
}

export default Section2;
